@if (canCopy || copyError) {
  <div class="container" >
    @if (!copied && !copyError) {
      <button class="btn btn-link" (click)="copy()">
        <ng-content></ng-content>
      </button>
    }
    @if (copied) {
      <div class="copied-text" trans="copy.button.success"></div>
    }
    @if (copyError) {
      <app-icon-message class="copy-error" messageType="alert">
        <span trans="copy.button.error"></span>
      </app-icon-message>
    }
  </div>
}
